import Axios from '../../library/Axios';

export const HomeAction = () => async (dispatch: any) => {
    try {
        dispatch({ type: 'HOME_REQUEST' })

        const { data } = await new Axios().get(`/get/home`)

        dispatch({ type: 'HOME_SUCCESS', payload: data })
    } catch (error) {
        dispatch({ type: 'HOME_ERROR' })
    }
}

export const PageAction = (page: string) => async (dispatch: any) => {
    try {
        dispatch({ type: 'PAGE_REQUEST' })

        const { data } = await new Axios().get(`/get/page/${page}`)

        dispatch({ type: 'PAGE_SUCCESS', payload: data })
    } catch (error) {
        dispatch({ type: 'PAGE_ERROR' })
    }
}

export const CategoryCampaignsAction = (category_id: string, page: number = 0) => async (dispatch: any) => {
    try {
        dispatch({ type: 'CATEGORY_CAMPAIGNS_REQUEST' })

        const { data } = await new Axios().get(`/get/category/${category_id}/${page}`)

        dispatch({ type: 'CATEGORY_CAMPAIGNS_SUCCESS', payload: data })
    } catch (error) {
        dispatch({ type: 'CATEGORY_CAMPAIGNS_ERROR' })
    } finally {
        // dispatch({ type: 'CATEGORY_CAMPAIGNS_RESET' });
    }
}

export const SubmitPaymentPostAction = (mobile: string, amount: string) => async (dispatch: any) => {
    try {
        dispatch({ type: 'SUBMIT_PAYMENT_POST_REQUEST' })

        const { data } = await new Axios().post(`/post/submit/payment`, {
            mobile: mobile,
            amount: Number(amount)
        });

        dispatch({ type: 'SUBMIT_PAYMENT_POST_SUCCESS', payload: data })
    } catch (error) {
        dispatch({ type: 'SUBMIT_PAYMENT_POST_ERROR' })
    }
}